/**
 * LCP / INP / CLS / TTFB / FCP through the same first-party channel as every
 * other browser event, under a `metric_type: "web_vital"` discriminator.
 * Sampled at 100% in v1. No third-party SDK, ever.
 */
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

import { isTelemetryEnabled, reportEvent } from './report';

function send(metric: Metric): void {
  reportEvent({
    message: `${metric.name} ${metric.value}`,
    metric_type: 'web_vital',
  });
}

export function installWebVitals(): void {
  if (!isTelemetryEnabled()) return;
  onCLS(send);
  onFCP(send);
  onINP(send);
  onLCP(send);
  onTTFB(send);
}
